import React from 'react'
import { contactLinkData } from '../../helper/Helper'

function AcceptPayments() {
    return (
        <div className='wrapper mx-auto'>
            <div className='d-flex flex-column flex-md-row justify-content-between gap-4 gap-xl-5'>
                <div className='w-100 max-w-650 bg-haiti border-ebonyclay rounded-4 p-4 px-xl-5'>
                    <div className='py-xl-1'>
                        <p className='transaction-line text-white fw-bold fs-22 position-relative border-white3 border-top-0 border-start-0 border-end-0 border-opacity-100 d-inline-block pb-2 m-0 mb-4'><span className='opacity-75'>Our Transactions Accept Payments Below</span></p>
                        <p className='text-white opacity-75 fw-bold fs-22'>Bank Lokal</p>
                        <div className='d-flex gap-2 flex-wrap'>
                            <div className='border border-1 border-white border-opacity-10 bg-darkslate rounded-3 px-2 px-lg-4 py-2'>
                                <p className='text-white opacity-75 fs-22 fw-medium m-0 mx-3'>BCA</p>
                            </div>
                            <div className='border border-1 border-white border-opacity-10 bg-darkslate rounded-3 px-2 px-lg-4 py-2'>
                                <p className='text-white opacity-75 fs-22 fw-medium m-0 mx-3'>Mandiri</p>
                            </div>
                            <div className='border border-1 border-white border-opacity-10 bg-darkslate rounded-3 px-2 px-lg-4 py-2'>
                                <p className='text-white opacity-75 fs-22 fw-medium m-0 mx-3'>BNI</p>
                            </div>
                            <div className='border border-1 border-white border-opacity-10 bg-darkslate rounded-3 px-2 px-lg-4 py-2'>
                                <p className='text-white opacity-75 fs-22 fw-medium m-0 mx-3'>BRI</p>
                            </div>
                            <div className='border border-1 border-white border-opacity-10 bg-darkslate rounded-3 px-2 px-lg-4 py-2'>
                                <p className='text-white opacity-75 fs-22 fw-medium m-0 mx-3'>CLIMB</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='w-100 max-w-543 bg-haiti border-ebonyclay rounded-4 p-4 px-xl-5'>
                    <div className="py-xl-1">
                        <p className='transaction-line text-white fw-bold fs-22 position-relative border-white3 border-top-0 border-start-0 border-end-0 border-opacity-100 max-w-206 pb-2 m-0 mb-4'><span className='opacity-75'>Contact Us</span></p>
                        <ul className='list-unstyled d-flex flex-column gap-2'>
                            {contactLinkData.map((data, index) => {
                                return (
                                    <li className='d-flex align-items-center gap-4' key={index}>
                                        {data.icon}
                                        <a href={data.link} target='_blank' rel="noreferrer" className='text-decoration-none text-white opacity-75 fw-medium m-0'>
                                            <span className='d-block fs-18 leading-100 opacity-50'>{data.title}</span>
                                            <span className='fs-16'>{data.linkTitle}</span>
                                        </a>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AcceptPayments